export default {"src":"/_next/static/media/followup.3eee26b1.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};